import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface CopyRequest {
    order_idx: number[];
}

export const usePostCopy = (successCallback?: () => void) => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (copyData: CopyRequest) => {
            const response = await axios.post(enum_api_uri.post_order_copy, copyData, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            return response.data.data.word_idx;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            successCallback?.();
        },
    });
};
